import LegalPage from "../../components/LegalPage";

export default function CGU() {
  return (
    <LegalPage
      title="Conditions Générales d'Utilisation"
      kicker="CGU"
      lastUpdated="08 juillet 2026"
      hideDraftNotice
    >
      <h2>1. Objet</h2>
      <p>
        Les présentes Conditions Générales d&apos;Utilisation, ci-après les
        <em> «&nbsp;CGU&nbsp;»</em>, ont pour objet de définir les conditions
        d&apos;accès et d&apos;utilisation du site et de la plateforme
        OTRAQUIZZ, accessible à l&apos;adresse :{" "}
        <a href="https://otra-gaming.fr" target="_blank" rel="noreferrer">
          https://otra-gaming.fr
        </a>
        .
      </p>
      <p>
        OTRAQUIZZ est une plateforme de quiz, défis chronométrés et événements
        live, permettant aux utilisateurs de participer à des épreuves de
        connaissance, de rapidité et de réflexion. Les défis peuvent prendre
        différentes formes, notamment&nbsp;:
      </p>
      <ul>
        <li>quiz standards&nbsp;;</li>
        <li>Golden Quizz&nbsp;;</li>
        <li>séries de quiz&nbsp;;</li>
        <li>événements live animés en salle ou à distance.</li>
      </ul>
      <p>
        Les présentes CGU s&apos;appliquent à tout utilisateur consultant,
        utilisant ou participant aux services proposés sur OTRAQUIZZ.
      </p>

      <h2>2. Éditeur du site</h2>
      <p>Le site OTRAQUIZZ est édité par&nbsp;:</p>
      <p>
        <strong>OTRA GAMING</strong>
        <br />
        Exploité par Jérôme HAGUETTE
        <br />
        SIRET&nbsp;: 508 788 569 00046
        <br />
        Adresse&nbsp;: 16 rue Hyacinthe Rigaud, 66680 Canohès
        <br />
        Email de contact&nbsp;:{" "}
        <a href="mailto:otragaming@outlook.fr">otragaming@outlook.fr</a>
      </p>
      <p>
        Ci-après désigné «&nbsp;OTRA GAMING&nbsp;», «&nbsp;OTRAQUIZZ&nbsp;»,
        «&nbsp;l&apos;Éditeur&nbsp;» ou «&nbsp;nous&nbsp;».
      </p>

      <h2>3. Acceptation des CGU</h2>
      <p>
        L&apos;utilisation du site OTRAQUIZZ implique l&apos;acceptation
        pleine et entière des présentes CGU.
      </p>
      <p>
        L&apos;utilisateur reconnaît avoir pris connaissance des CGU avant
        toute création de compte, achat de code, participation à un défi ou
        inscription à un événement live.
      </p>
      <p>
        Si l&apos;utilisateur n&apos;accepte pas les présentes CGU, il doit
        cesser d&apos;utiliser le site et les services OTRAQUIZZ.
      </p>

      <h2>4. Description du service</h2>
      <p>
        OTRAQUIZZ propose des quiz et défis dans lesquels les participants
        répondent à des questions à choix multiples dans un temps limité.
      </p>
      <p>Les classements sont établis selon des critères objectifs, notamment&nbsp;:</p>
      <ul>
        <li>le nombre de bonnes réponses&nbsp;;</li>
        <li>le score obtenu&nbsp;;</li>
        <li>le temps de réponse&nbsp;;</li>
        <li>les règles propres à chaque défi ou événement.</li>
      </ul>
      <p>OTRAQUIZZ peut proposer&nbsp;:</p>
      <ul>
        <li>des défis gratuits&nbsp;;</li>
        <li>des défis accessibles par code standard&nbsp;;</li>
        <li>des Golden Quizz accessibles par Golden Code&nbsp;;</li>
        <li>des événements live avec inscription ou code d&apos;accès&nbsp;;</li>
        <li>des classements et récompenses selon les modalités affichées pour chaque défi.</li>
      </ul>
      <p>
        <strong>OTRAQUIZZ n&apos;est pas un jeu de hasard.</strong> Les
        gagnants ne sont pas désignés par tirage au sort ou par mécanisme
        aléatoire. Les résultats dépendent des réponses données par les
        participants et de leurs performances selon les règles de classement
        applicables.
      </p>

      <h2>5. Accès au site</h2>
      <p>Le site est accessible depuis un navigateur internet compatible.</p>
      <p>
        OTRA GAMING s&apos;efforce d&apos;assurer l&apos;accès au service, sans
        garantir une disponibilité permanente ou sans interruption. L&apos;accès
        au site peut être temporairement suspendu pour&nbsp;:
      </p>
      <ul>
        <li>maintenance&nbsp;;</li>
        <li>mise à jour&nbsp;;</li>
        <li>correction technique&nbsp;;</li>
        <li>incident de sécurité&nbsp;;</li>
        <li>force majeure&nbsp;;</li>
        <li>problème indépendant de la volonté de l&apos;Éditeur.</li>
      </ul>
      <p>
        L&apos;utilisateur reconnaît que le bon fonctionnement du service
        dépend notamment de son matériel, de son navigateur, de son système
        d&apos;exploitation et de sa connexion internet.
      </p>

      <h2>6. Création de compte</h2>
      <p>
        Certaines fonctionnalités nécessitent la création ou la connexion à un
        compte utilisateur, notamment&nbsp;:
      </p>
      <ul>
        <li>l&apos;achat de codes&nbsp;;</li>
        <li>l&apos;accès à l&apos;espace «&nbsp;Mes codes&nbsp;»&nbsp;;</li>
        <li>la participation à certains défis&nbsp;;</li>
        <li>l&apos;accès aux événements live&nbsp;;</li>
        <li>la consultation des classements personnalisés&nbsp;;</li>
        <li>la réclamation d&apos;un gain éventuel.</li>
      </ul>
      <p>
        L&apos;utilisateur peut se connecter ou créer un compte via les moyens
        proposés par la plateforme, notamment&nbsp;:
      </p>
      <ul>
        <li>connexion avec Google&nbsp;;</li>
        <li>connexion par email et mot de passe&nbsp;;</li>
        <li>tout autre moyen d&apos;authentification ajouté ultérieurement.</li>
      </ul>
      <p>
        L&apos;utilisateur s&apos;engage à fournir des informations exactes,
        complètes et à jour.
      </p>

      <h2>7. Âge minimum</h2>
      <p>
        L&apos;utilisation des services OTRAQUIZZ impliquant un achat, une
        participation payante, une cagnotte, une récompense ou la réclamation
        d&apos;un gain est <strong>strictement réservée aux personnes âgées de
        18 ans minimum</strong>.
      </p>
      <p>
        En créant un compte, en achetant un code, en participant à un défi
        payant, en rejoignant un événement payant ou en réclamant un gain,
        l&apos;utilisateur déclare être majeur et avoir au moins 18 ans.
      </p>
      <p>
        La participation aux défis payants, aux Golden Quizz, aux événements
        payants et à tout défi comportant une cagnotte, une récompense ou un
        gain est réservée aux personnes âgées de 18 ans minimum.
      </p>
      <p>
        OTRA GAMING se réserve le droit de demander tout justificatif
        permettant de vérifier l&apos;âge de l&apos;utilisateur, notamment en
        cas de réclamation de gain, de suspicion de fraude ou de contestation.
      </p>
      <p>
        Si OTRA GAMING constate qu&apos;un utilisateur mineur a participé à un
        service réservé aux majeurs, OTRA GAMING pourra notamment&nbsp;:
      </p>
      <ul>
        <li>suspendre ou supprimer le compte concerné&nbsp;;</li>
        <li>annuler la participation&nbsp;;</li>
        <li>annuler le score&nbsp;;</li>
        <li>refuser ou annuler le gain éventuel&nbsp;;</li>
        <li>prendre toute mesure nécessaire pour respecter la réglementation applicable.</li>
      </ul>
      <p>
        Les personnes mineures ne sont pas autorisées à acheter des codes,
        participer à des défis payants avec cagnotte, ni réclamer un gain sur
        OTRAQUIZZ.
      </p>

      <h2>8. Identifiants et sécurité du compte</h2>
      <p>
        L&apos;utilisateur est responsable de la confidentialité de ses
        identifiants de connexion. Il s&apos;engage à ne pas communiquer son
        compte, ses accès ou ses codes personnels à un tiers.
      </p>
      <p>
        Toute action réalisée depuis le compte de l&apos;utilisateur est
        réputée effectuée par lui, sauf preuve contraire.
      </p>
      <p>
        En cas d&apos;utilisation frauduleuse, de suspicion de piratage ou
        d&apos;accès non autorisé, l&apos;utilisateur doit contacter OTRA
        GAMING à l&apos;adresse suivante&nbsp;:{" "}
        <a href="mailto:otragaming@outlook.fr">otragaming@outlook.fr</a>.
      </p>

      <h2>9. Pseudo utilisateur</h2>
      <p>
        Lors de sa première connexion ou avant de participer à un défi,
        l&apos;utilisateur peut être invité à choisir un pseudo. Le pseudo est
        utilisé pour l&apos;affichage dans les classements, les résultats et
        les événements live.
      </p>
      <p>Le pseudo doit respecter les règles suivantes&nbsp;:</p>
      <ul>
        <li>être unique sur la plateforme&nbsp;;</li>
        <li>ne pas usurper l&apos;identité d&apos;un tiers&nbsp;;</li>
        <li>ne pas contenir de propos injurieux, discriminatoires, haineux, sexuels, violents ou illicites&nbsp;;</li>
        <li>ne pas porter atteinte aux droits d&apos;un tiers&nbsp;;</li>
        <li>ne pas contenir de marque, nom commercial ou élément protégé sans autorisation&nbsp;;</li>
        <li>respecter les limites techniques fixées par la plateforme.</li>
      </ul>
      <p>
        OTRA GAMING se réserve le droit de modifier, suspendre ou supprimer un
        pseudo manifestement contraire aux présentes CGU.
      </p>

      <h2>10. Codes de participation</h2>
      <p>OTRAQUIZZ peut fonctionner avec différents types de codes, notamment&nbsp;:</p>
      <ul>
        <li>codes standards&nbsp;;</li>
        <li>Golden Codes&nbsp;;</li>
        <li>codes d&apos;accès événement live&nbsp;;</li>
        <li>codes promotionnels ou codes générés manuellement par l&apos;administrateur.</li>
      </ul>
      <p>
        Les codes standards permettent d&apos;accéder à certains quiz ou défis
        standards. Les Golden Codes permettent d&apos;accéder aux Golden Quizz.
        Les codes d&apos;événements live permettent de rejoindre une salle ou
        un événement live dédié.
      </p>
      <p>
        Les codes sont personnels et rattachés au compte utilisateur lorsqu&apos;ils
        sont achetés ou utilisés, sauf indication contraire.
      </p>
      <p>Un code peut avoir différents statuts, notamment&nbsp;:</p>
      <ul>
        <li>disponible&nbsp;;</li>
        <li>réservé&nbsp;;</li>
        <li>utilisé&nbsp;;</li>
        <li>consommé&nbsp;;</li>
        <li>expiré&nbsp;;</li>
        <li>annulé&nbsp;;</li>
        <li>remboursé.</li>
      </ul>
      <p>
        Un code utilisé, consommé, expiré ou réservé pour un défi ne peut pas
        être réutilisé, sauf décision exceptionnelle de l&apos;Éditeur.
      </p>

      <h2>11. Achat de codes</h2>
      <p>
        Les achats de codes sont encadrés par les Conditions Générales de
        Vente, accessibles sur le site.
      </p>
      <p>
        Les codes achetés sont mis à disposition dans l&apos;espace personnel
        de l&apos;utilisateur, notamment dans la rubrique «&nbsp;Mes codes&nbsp;».
      </p>
      <p>
        Le paiement est traité par un prestataire de paiement sécurisé,
        notamment Stripe. OTRA GAMING ne stocke pas les informations complètes
        de carte bancaire de l&apos;utilisateur.
      </p>
      <p>
        Les codes ne sont générés qu&apos;après confirmation du paiement selon
        les règles techniques prévues par la plateforme.
      </p>

      <h2>12. Participation aux défis</h2>
      <p>Pour participer à un défi, l&apos;utilisateur doit&nbsp;:</p>
      <ul>
        <li>disposer d&apos;un compte valide&nbsp;;</li>
        <li>disposer d&apos;un pseudo valide&nbsp;;</li>
        <li>utiliser un code compatible si le défi en nécessite un&nbsp;;</li>
        <li>respecter les règles propres au défi&nbsp;;</li>
        <li>disposer d&apos;une connexion internet suffisante&nbsp;;</li>
        <li>avoir au moins 18 ans lorsque le défi est payant, comporte une cagnotte, une récompense ou permet la réclamation d&apos;un gain.</li>
      </ul>
      <p>Chaque défi peut comporter&nbsp;:</p>
      <ul>
        <li>une date et heure d&apos;ouverture&nbsp;;</li>
        <li>une date et heure de fermeture&nbsp;;</li>
        <li>un nombre de questions&nbsp;;</li>
        <li>une durée par question&nbsp;;</li>
        <li>une cagnotte ou récompense éventuelle&nbsp;;</li>
        <li>une répartition des gains&nbsp;;</li>
        <li>des règles spécifiques de classement.</li>
      </ul>
      <p>
        L&apos;utilisateur doit consulter les informations du défi avant de
        participer.
      </p>

      <h2>13. Défis à venir et réservations</h2>
      <p>Certains défis peuvent être annoncés avant leur ouverture.</p>
      <p>
        L&apos;utilisateur peut, lorsque la fonctionnalité est disponible,
        réserver un code pour un défi à venir. Lorsqu&apos;un code est réservé
        pour un défi à venir, il est associé à ce défi et ne peut plus être
        utilisé librement sur un autre défi, sauf annulation du défi par
        l&apos;Éditeur ou décision exceptionnelle.
      </p>
      <p>
        Si l&apos;utilisateur ne participe pas au défi pendant sa période
        d&apos;ouverture, le code réservé peut être considéré comme expiré ou
        non utilisé, sans remboursement automatique.
      </p>

      <h2>14. Déroulement des quiz</h2>
      <p>Les quiz sont composés de questions à choix multiples.</p>
      <p>Chaque question peut être soumise à un temps limité.</p>
      <p>
        Le compte à rebours démarre selon les règles techniques du mode
        concerné&nbsp;:
      </p>
      <ul>
        <li>dès l&apos;affichage de la question pour les défis en ligne&nbsp;;</li>
        <li>au lancement par l&apos;animateur ou l&apos;administrateur dans le cadre d&apos;un événement live.</li>
      </ul>
      <p>Le score peut dépendre&nbsp;:</p>
      <ul>
        <li>de la bonne réponse&nbsp;;</li>
        <li>de la rapidité de réponse&nbsp;;</li>
        <li>du nombre de questions&nbsp;;</li>
        <li>des paramètres du défi&nbsp;;</li>
        <li>des règles particulières indiquées dans le défi.</li>
      </ul>
      <p>
        Une réponse non donnée dans le temps imparti peut être considérée
        comme incorrecte ou sans réponse.
      </p>

      <h2>15. Événements live</h2>
      <p>
        OTRAQUIZZ peut proposer des événements live, organisés en salle, à
        distance ou dans un lieu défini.
      </p>
      <p>Dans un événement live&nbsp;:</p>
      <ul>
        <li>les participants rejoignent une room dédiée&nbsp;;</li>
        <li>les questions peuvent être affichées sur écran géant&nbsp;;</li>
        <li>les participants répondent sur leur téléphone&nbsp;;</li>
        <li>l&apos;animateur ou l&apos;administrateur contrôle le rythme de l&apos;événement&nbsp;;</li>
        <li>le passage entre les quiz ou certaines étapes peut dépendre d&apos;une action de l&apos;animateur&nbsp;;</li>
        <li>des classements intermédiaires ou finaux peuvent être affichés.</li>
      </ul>
      <p>Les événements live peuvent comporter plusieurs quiz successifs.</p>
      <p>
        Chaque événement live peut avoir ses propres conditions d&apos;accès,
        de participation, de prix, de récompense et de classement.
      </p>
      <p>
        Sauf indication contraire affichée pour l&apos;événement concerné, les
        participants peuvent rejoindre un événement live même après son
        démarrage.
      </p>
      <p>En cas d&apos;arrivée en cours d&apos;événement&nbsp;:</p>
      <ul>
        <li>le participant rejoint l&apos;événement à l&apos;étape actuellement en cours&nbsp;;</li>
        <li>il ne peut pas répondre aux questions déjà terminées&nbsp;;</li>
        <li>les questions déjà passées peuvent être comptabilisées comme non répondues ou à zéro point&nbsp;;</li>
        <li>son classement est calculé uniquement selon les réponses enregistrées à partir de son arrivée&nbsp;;</li>
        <li>il accepte que son arrivée tardive puisse réduire ses chances d&apos;obtenir un bon classement ou un gain.</li>
      </ul>
      <p>
        OTRA GAMING se réserve le droit de limiter ou refuser les arrivées en
        cours d&apos;événement pour certains événements spécifiques, notamment
        pour des raisons techniques, d&apos;équité, de capacité d&apos;accueil
        ou d&apos;organisation. Dans ce cas, cette restriction sera indiquée
        sur la page ou les conditions de l&apos;événement concerné.
      </p>
      <p>
        Pour les événements live payants ou comportant des récompenses, la
        participation est réservée aux personnes âgées de 18 ans minimum.
      </p>

      <h2>16. Classements</h2>
      <p>
        Les classements sont établis selon les règles propres à chaque défi ou
        événement.
      </p>
      <p>
        Sauf indication contraire, les critères de classement peuvent inclure&nbsp;:
      </p>
      <ul>
        <li>le score total&nbsp;;</li>
        <li>le temps de réponse&nbsp;;</li>
        <li>le nombre de bonnes réponses&nbsp;;</li>
        <li>l&apos;ordre de participation ou tout autre critère technique de départage indiqué.</li>
      </ul>
      <p>
        Pour certains défis, un même utilisateur peut participer plusieurs
        fois avec plusieurs codes. Toutefois, sauf mention contraire, seul le
        meilleur score de l&apos;utilisateur est retenu pour le classement
        récompensé.
      </p>
      <p>
        Un même utilisateur ne peut pas occuper plusieurs places gagnantes
        dans un même défi avec plusieurs participations.
      </p>

      <h2>17. Récompenses et gains</h2>
      <p>
        Certains défis ou événements peuvent proposer une cagnotte, des
        récompenses ou des lots.
      </p>
      <p>
        Les récompenses éventuelles sont indiquées avant participation,
        lorsque cela est applicable.
      </p>
      <p>
        La cagnotte peut être définie librement par l&apos;administrateur du
        défi. La répartition des gains peut prévoir un ou plusieurs gagnants,
        par exemple&nbsp;:
      </p>
      <ul>
        <li>1er&nbsp;: 50&nbsp;%&nbsp;;</li>
        <li>2e&nbsp;: 30&nbsp;%&nbsp;;</li>
        <li>3e&nbsp;: 20&nbsp;%.</li>
      </ul>
      <p>
        Les montants, pourcentages, lots ou conditions de récompense sont ceux
        affichés sur la page du défi ou de l&apos;événement.
      </p>
      <p>
        Aucun gain n&apos;est définitivement acquis tant que le défi n&apos;est
        pas finalisé et que les vérifications techniques et antifraude
        n&apos;ont pas été effectuées.
      </p>
      <p>La réclamation d&apos;un gain est réservée aux personnes âgées de 18 ans minimum.</p>

      <h2>18. Réclamation des gains</h2>
      <p>
        Lorsqu&apos;un utilisateur est éligible à un gain, il peut être invité
        à réclamer son gain depuis l&apos;interface prévue à cet effet.
      </p>
      <p>
        Pour permettre le paiement manuel du gain, l&apos;utilisateur devra
        fournir certaines informations, notamment&nbsp;:
      </p>
      <ul>
        <li>nom du titulaire du compte bancaire&nbsp;;</li>
        <li>IBAN&nbsp;;</li>
        <li>BIC/SWIFT optionnel&nbsp;;</li>
        <li>toute information complémentaire nécessaire au traitement du paiement.</li>
      </ul>
      <p>
        Les informations bancaires sont utilisées uniquement pour le
        traitement du gain et ne sont pas affichées publiquement.
      </p>
      <p>OTRA GAMING peut refuser ou suspendre le paiement d&apos;un gain en cas de&nbsp;:</p>
      <ul>
        <li>fraude&nbsp;;</li>
        <li>tentative de fraude&nbsp;;</li>
        <li>compte multiple abusif&nbsp;;</li>
        <li>incohérence d&apos;identité ou de compte&nbsp;;</li>
        <li>utilisateur mineur ou impossibilité de vérifier la majorité de l&apos;utilisateur&nbsp;;</li>
        <li>utilisation d&apos;un code appartenant à un tiers&nbsp;;</li>
        <li>manipulation technique&nbsp;;</li>
        <li>violation des présentes CGU&nbsp;;</li>
        <li>contestation en cours.</li>
      </ul>

      <h2>19. Comportements interdits</h2>
      <p>L&apos;utilisateur s&apos;interdit notamment de&nbsp;:</p>
      <ul>
        <li>créer plusieurs comptes dans le but de contourner les règles&nbsp;;</li>
        <li>utiliser le compte ou les codes d&apos;un tiers&nbsp;;</li>
        <li>partager ou revendre un code sans autorisation&nbsp;;</li>
        <li>tenter de manipuler les scores&nbsp;;</li>
        <li>utiliser un robot, script, automatisation ou outil de triche&nbsp;;</li>
        <li>perturber le fonctionnement du site&nbsp;;</li>
        <li>exploiter une faille technique&nbsp;;</li>
        <li>tenter d&apos;accéder à des données non autorisées&nbsp;;</li>
        <li>tenir des propos injurieux, menaçants, discriminatoires ou illicites&nbsp;;</li>
        <li>usurper l&apos;identité d&apos;une personne physique ou morale&nbsp;;</li>
        <li>déclarer faussement être majeur pour accéder à un service réservé aux personnes de 18 ans minimum.</li>
      </ul>
      <p>Toute violation peut entraîner, sans indemnité&nbsp;:</p>
      <ul>
        <li>suspension du compte&nbsp;;</li>
        <li>suppression du compte&nbsp;;</li>
        <li>annulation d&apos;une participation&nbsp;;</li>
        <li>annulation d&apos;un score&nbsp;;</li>
        <li>exclusion d&apos;un classement&nbsp;;</li>
        <li>refus ou annulation d&apos;un gain&nbsp;;</li>
        <li>blocage de l&apos;accès au service.</li>
      </ul>

      <h2>20. Contrôles antifraude</h2>
      <p>
        OTRA GAMING peut effectuer des contrôles avant, pendant ou après un
        défi. Ces contrôles peuvent porter notamment sur&nbsp;:
      </p>
      <ul>
        <li>les comptes utilisateurs&nbsp;;</li>
        <li>les codes utilisés&nbsp;;</li>
        <li>les temps de réponse&nbsp;;</li>
        <li>les scores&nbsp;;</li>
        <li>les connexions suspectes&nbsp;;</li>
        <li>les comportements anormaux&nbsp;;</li>
        <li>les réclamations de gains&nbsp;;</li>
        <li>la vérification de la majorité d&apos;un utilisateur lorsque cela est nécessaire.</li>
      </ul>
      <p>
        L&apos;objectif est de garantir l&apos;équité des classements et la
        sécurité de la plateforme.
      </p>

      <h2>21. Annulation, report ou modification d&apos;un défi</h2>
      <p>
        OTRA GAMING se réserve le droit d&apos;annuler, reporter, modifier ou
        clôturer un défi ou un événement en cas de&nbsp;:
      </p>
      <ul>
        <li>erreur manifeste&nbsp;;</li>
        <li>bug technique&nbsp;;</li>
        <li>problème de paiement&nbsp;;</li>
        <li>suspicion de fraude&nbsp;;</li>
        <li>nombre insuffisant de participants&nbsp;;</li>
        <li>incident indépendant de sa volonté&nbsp;;</li>
        <li>force majeure&nbsp;;</li>
        <li>nécessité légale, administrative ou technique.</li>
      </ul>
      <p>
        En cas d&apos;annulation d&apos;un défi par OTRA GAMING, les codes
        réservés ou utilisés pourront, selon la situation, être réactivés,
        remplacés, recrédités ou remboursés.
      </p>

      <h2>22. Responsabilité de l&apos;utilisateur</h2>
      <p>L&apos;utilisateur est responsable&nbsp;:</p>
      <ul>
        <li>de son matériel&nbsp;;</li>
        <li>de sa connexion internet&nbsp;;</li>
        <li>de son navigateur&nbsp;;</li>
        <li>de ses identifiants&nbsp;;</li>
        <li>des informations qu&apos;il fournit&nbsp;;</li>
        <li>de l&apos;utilisation de son compte&nbsp;;</li>
        <li>de sa participation aux défis.</li>
      </ul>
      <p>
        OTRA GAMING ne peut être tenu responsable si l&apos;utilisateur ne peut
        pas participer en raison d&apos;un problème relevant de son propre
        matériel, de sa connexion, de son navigateur ou d&apos;une mauvaise
        utilisation du service.
      </p>

      <h2>23. Responsabilité d&apos;OTRA GAMING</h2>
      <p>
        OTRA GAMING s&apos;efforce de fournir un service fonctionnel, sécurisé
        et accessible. Toutefois, OTRA GAMING ne garantit pas&nbsp;:
      </p>
      <ul>
        <li>l&apos;absence totale d&apos;erreurs&nbsp;;</li>
        <li>l&apos;absence d&apos;interruption&nbsp;;</li>
        <li>l&apos;absence de bugs&nbsp;;</li>
        <li>la compatibilité avec tous les appareils&nbsp;;</li>
        <li>l&apos;accès permanent au service.</li>
      </ul>
      <p>
        En cas de problème technique affectant un défi, OTRA GAMING se réserve
        le droit de prendre toute décision nécessaire pour préserver
        l&apos;équité, notamment&nbsp;:
      </p>
      <ul>
        <li>relancer un défi&nbsp;;</li>
        <li>annuler un défi&nbsp;;</li>
        <li>corriger un classement&nbsp;;</li>
        <li>suspendre le paiement d&apos;un gain&nbsp;;</li>
        <li>rembourser ou réactiver certains codes.</li>
      </ul>

      <h2>24. Propriété intellectuelle</h2>
      <p>
        Le site OTRAQUIZZ, son nom, son logo, son interface, ses textes,
        éléments graphiques, contenus, questions, classements, bases de
        données et éléments visuels sont protégés par le droit de la propriété
        intellectuelle.
      </p>
      <p>
        Toute reproduction, représentation, modification, adaptation,
        extraction ou exploitation non autorisée est interdite.
      </p>
      <p>
        L&apos;utilisateur ne dispose que d&apos;un droit personnel, non
        exclusif et non transférable d&apos;accès au site dans le cadre normal
        de son utilisation.
      </p>

      <h2>25. Contenus des utilisateurs</h2>
      <p>
        L&apos;utilisateur peut être amené à fournir certains contenus ou
        informations, notamment&nbsp;:
      </p>
      <ul>
        <li>pseudo&nbsp;;</li>
        <li>réponses aux quiz&nbsp;;</li>
        <li>messages éventuels&nbsp;;</li>
        <li>informations de compte&nbsp;;</li>
        <li>informations liées à une réclamation de gain.</li>
      </ul>
      <p>
        L&apos;utilisateur garantit que les contenus fournis ne portent pas
        atteinte aux droits de tiers et ne sont pas illicites.
      </p>
      <p>
        OTRA GAMING peut supprimer ou masquer tout contenu contraire aux
        présentes CGU ou à la loi.
      </p>

      <h2>26. Données personnelles</h2>
      <p>
        OTRA GAMING traite certaines données personnelles dans le cadre du
        fonctionnement du site. Les traitements peuvent notamment concerner&nbsp;:
      </p>
      <ul>
        <li>la création de compte&nbsp;;</li>
        <li>l&apos;authentification&nbsp;;</li>
        <li>l&apos;achat de codes&nbsp;;</li>
        <li>la participation aux défis&nbsp;;</li>
        <li>l&apos;établissement des classements&nbsp;;</li>
        <li>la gestion des gains&nbsp;;</li>
        <li>la prévention de la fraude&nbsp;;</li>
        <li>le support utilisateur&nbsp;;</li>
        <li>la vérification de la majorité lorsque cela est nécessaire.</li>
      </ul>
      <p>
        Pour plus d&apos;informations, l&apos;utilisateur est invité à
        consulter la Politique de confidentialité accessible sur le site.
      </p>
      <p>
        Pour toute demande relative aux données personnelles, l&apos;utilisateur
        peut écrire à&nbsp;:{" "}
        <a href="mailto:otragaming@outlook.fr">otragaming@outlook.fr</a>.
      </p>

      <h2>27. Cookies</h2>
      <p>
        Le site peut utiliser des cookies ou technologies similaires
        nécessaires à son fonctionnement.
      </p>
      <p>
        Des cookies non essentiels peuvent également être utilisés sous
        réserve du consentement de l&apos;utilisateur lorsque la réglementation
        l&apos;exige.
      </p>
      <p>
        Pour plus d&apos;informations, l&apos;utilisateur est invité à
        consulter la Politique de cookies accessible sur le site.
      </p>

      <h2>28. Suspension ou suppression de compte</h2>
      <p>OTRA GAMING peut suspendre ou supprimer un compte utilisateur en cas de&nbsp;:</p>
      <ul>
        <li>violation des CGU&nbsp;;</li>
        <li>fraude ou tentative de fraude&nbsp;;</li>
        <li>comportement abusif&nbsp;;</li>
        <li>atteinte à la sécurité du service&nbsp;;</li>
        <li>utilisation illicite&nbsp;;</li>
        <li>demande légale ou administrative&nbsp;;</li>
        <li>fausse déclaration relative à l&apos;âge de l&apos;utilisateur.</li>
      </ul>
      <p>
        L&apos;utilisateur peut également demander la suppression de son
        compte, sous réserve des données devant être conservées pour des
        raisons légales, comptables, probatoires ou antifraude.
      </p>

      <h2>29. Modification des CGU</h2>
      <p>
        OTRA GAMING se réserve le droit de modifier les présentes CGU à tout
        moment. Les nouvelles CGU entrent en vigueur à compter de leur
        publication sur le site.
      </p>
      <p>
        L&apos;utilisateur est invité à consulter régulièrement les CGU. En
        cas de modification importante, OTRA GAMING pourra informer les
        utilisateurs par tout moyen approprié.
      </p>

      <h2>30. Droit applicable</h2>
      <p>Les présentes CGU sont soumises au droit français.</p>
      <p>
        En cas de litige, l&apos;utilisateur est invité à contacter OTRA
        GAMING afin de rechercher une solution amiable.
      </p>
      <p>
        Email de contact&nbsp;:{" "}
        <a href="mailto:otragaming@outlook.fr">otragaming@outlook.fr</a>.
      </p>

      <h2>31. Contact</h2>
      <p>
        Pour toute question relative aux présentes CGU ou à l&apos;utilisation
        du site, l&apos;utilisateur peut contacter OTRA GAMING à l&apos;adresse
        suivante&nbsp;:{" "}
        <a href="mailto:otragaming@outlook.fr">otragaming@outlook.fr</a>.
      </p>
    </LegalPage>
  );
}
